import { TipoAmbienteExterno } from '../../types/negocio/AmbienteExterno';
import InfoHeader from '../InfoHeader';
import TabelaPESTEL from '../TabelaPESTEL';
import { Box } from '@mui/material';

interface AmbienteExternoTipoProps {
  tipo: TipoAmbienteExterno;
  titulo: string;
  descricao: string;
}

const AmbienteExternoTipo = (props: AmbienteExternoTipoProps) => {
  return (<Box>
    <InfoHeader
      title={props.titulo}
      message={props.descricao}
      isImportant
      url='https://youtu.be/skcceGAKkmM'
      modalTitle='Entenda a aba Ambiente Externo'
    />
    <TabelaPESTEL tipo={props.tipo} />
  </Box>)
}

export default AmbienteExternoTipo;